
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  declare inputTarget: HTMLInputElement

  toggleSelection() {
    const input = this.inputTarget
    if (input.checked) {
      this.element.classList.add("selected")
    } else {
      this.element.classList.remove("selected")
    }
  }
}
